module.exports = __webpack_public_path__ + "img/userbase.bd3eec4e.png";